import { combineReducers } from 'redux';
import images from './images';
import diffusion from './diffusion';
import questions from './questions';
import { INITIAL_DATA_LOAD_SUCCESS } from '../actions';

const isFetched = (state = false, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  isFetched,
  diffusion,
  images,
  questions,
});

export const getIsFetched = state => state.isFetched;



// WEBPACK FOOTER //
// ./src/modules/survey/reducers/index.js